import { useMsal } from '@azure/msal-react'
import {
  Body2,
  Box,
  Button,
  ButtonGroup,
  Display3,
  Flex,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import React from 'react'

import ProductionPlanningHeader from './PlannerSelection/ProductionPlanningHeader'

const NotFoundPage = () => {
  const { instance } = useMsal()

  const onReload = () => {
    window.location.href = window.location.origin
  }

  return (
    <>
      <Box
        backgroundColor='primary'
        className='main-error-page'
        style={{ width: '100%', margin: 0, padding: 0 }}
      >
        <Box
          backgroundColor='secondary'
          border={{ radius: 'md', size: 'md' }}
          style={{ width: '100%' }}
        >
          <ProductionPlanningHeader headerMessage={'Production Planning'} />
        </Box>
        <Flex
          direction='column'
          alignItems='center'
          gap='lg'
          style={{ minHeight: 'calc(100vh - 56px)' }}
        >
          <Box
            backgroundColor='secondary'
            padding={{ sm: 'md', md: 'lg' }}
            style={{
              maxWidth: 1800,
              width: '100%',
              marginTop: '2rem',
              boxSizing: 'border-box',
            }}
          >
            <Flex
              direction='column'
              alignItems='center'
              justifyContent='center'
              gap='sm'
            >
              <AlertCircleFilled className='c-common-error_icon-larger' />

              <div className='c-common-error_primaryMessage'>
                <Display3
                  style={{
                    textAlign: 'center',
                    marginTop: '8px',
                    marginBottom: '16px',
                  }}
                >
                  404 Not Found
                </Display3>
              </div>

              <div className='c-common-error_secondaryMessage'>
                <Body2 style={{ textAlign: 'center', margin: 0 }}>
                  Sorry, we cannot found out the requested page.
                </Body2>
              </div>

              <div className='c-common-error_secondaryMessage'>
                <Body2 style={{ textAlign: 'center', marginBottom: '16px' }}>
                  Please try again.
                </Body2>
              </div>
              <ButtonGroup align='center' gap='lg'>
                <Button onClick={() => onReload()} testid='back-button'>
                  Back to Production Planning
                </Button>

                <Button
                  onClick={() => void instance.logoutRedirect()}
                  testid='logout-button'
                  variant='secondary'
                  style={{
                    backgroundColor: 'var(--fable-color-background, #fff)',
                  }}
                >
                  Logout
                </Button>
              </ButtonGroup>
            </Flex>
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default NotFoundPage
